module.exports = __webpack_public_path__ + "img/appIcon-menu--AccountDashboard--active.e6e96a82.svg";